import { useEffect, useRef, useState } from "react";
import { getLPHours, getLPNames } from "../../../config";
import { DatePicker } from 'antd';
import moment from "moment";
import { CSVLink } from "react-csv";

const { RangePicker } = DatePicker;



export const LPHours = () => {
    const [leaders, setLeaders] = useState([]);
    const [leaderSelected, setLeaderSelected] = useState()
    const [range, setRange] = useState({ start: null, end: null });
    const [hours, setHours] = useState([])
    const buttonCSV = useRef();
    const [isLoading, setIsLoading] = useState(false);




    useEffect(() => {
        getLPNames().then(({ payload }) => {
            setLeaders(payload)
        })
    }, [])

    const disabledDate = (currentDate) => {
        const current = new Date(currentDate);
        // Can not select days before today and today
        return current && moment(current).isAfter(moment(new Date()))
    };

    const downloadCSV = async () => {
        setIsLoading(true)
        const { end: endAt, start: startAt } = range;
        const { payload } = await getLPHours({ endAt, leaderId: leaderSelected?.id, startAt })
        setHours(payload.map(({ leader, task, subTasks, date, time }) => {
            return {
                "Líder": leader,
                Tarea: task,
                "Subtarea": subTasks,
                Fecha: moment(date).format("DD/MM/YYYY"),
                Tiempo: time
            }
        }))

        setIsLoading(false)

    }

    const download = () => {
        setIsLoading(true)

        buttonCSV.current.link.click();
        setIsLoading(false)
        setLeaderSelected(null);
        setHours([])
        setRange({ end: null, start: null })

    }





    return (
        <div className="w-full flex flex-col gap-3 p-4">
            {isLoading ? <p>Loading....</p> :
                (<><div className="w-full flex gap-4  h-fit">
                    {leaders.map(leader => {
                        return (
                            <div
                                key={leader.id}
                                onClick={() => setLeaderSelected(leader)}
                                className={`w-32 h-16  flex justify-center items-center rounded-md hover:bg-slate-500 hover:cursor-pointer hover:text-white ${leaderSelected?.id === leader.id ? "bg-[#49829E] text-white" : "bg-gray-300"}`}>
                                <p>{leader.name}</p>
                            </div>
                        )
                    })}
                </div>
                    <div className=" flex  gap-5">
                        <RangePicker disabledDate={disabledDate}
                            onChange={(newRange) => {
                                if (!newRange) return setRange({ end: null, start: null })
                                setRange({ end: new Date(newRange[1]), start: new Date(newRange[0]) })
                            }} />
                        <button onClick={hours.length === 0 ? downloadCSV : download} disabled={!leaderSelected || !range.start} className="p-2 bg-[#49829E] rounded-lg text-white active:scale-105 duration-300 disabled:bg-gray-500 disabled:cursor-not-allowed">{hours.length === 0 ? "Obtener tiempos" : "Descargar tiempos"}</button>

                        <CSVLink filename={`lider-${leaderSelected?.name}-${moment().format('YYYY-MM-DD HH:mm')}`} data={hours} className="hidden" ref={buttonCSV} />


                    </div></>)}

        </div>
    );
}

export default LPHours;